/**
 * page 1: Allgemein
 */
export const GENERAL_FIELD_NAMES = {
  cooperative: "Genossenschaft",
  customerName: "Kunde_Name_und_Vorname",
  mail: "Kunde_E-Mail",
  phone: "Kunde_Telefonnummer",
  orderName: "Auftragsname",
  deliveryDate: "Liefertermin",
  previewDesired: "Preview_gewünscht",
  fromDate: "Schaltung_von",
  toDate: "Schaltung_bis_und_mit",
};

export const CONTENT_FIELD_NAMES = {
  typeOfOrder: "Art_der_Bestellung",
  nameOfOldSpot: "Name_des_alten_Spots",
  spotTitle: "Spot_Titel",
  spotText: "Spot_Text",
  jlsAllowedToChangeText: "jls_darf_Text_kürzen",
  spotCallToAction: "Call_to_Action",
  notes: "Bemerkungen_und_Spezielles",
};

export const CHARACTERISTICS_FIELD_NAMES = {
  customerZone: "Ausprägungen_Kundenzone",
  shopWindow: "Ausprägungen_Schaufenster",
  businessLocations: "Geschäftsstellen",
  notesSignage: "Bemerkungen_Ausprägungen_Signage",
  website: "Ausprägungen_Webseite",
  facebook: "Ausprägungen_Facebook",
  instagram: "Ausprägungen_Instagram",
  tikTok: "Ausprägungen_TikTok",
  linkedIn: "Ausprägungen_LinkedIn",
  audio: "Audio",
  subTitle: "Untertitel_gewünscht",
  furtherNotes: "Bemerkung_Weitere_Ausprägungen",
};

export const RESOURCES_FIELD_NAMES = {
  typeOfResources: "Art_der_Ressourcen",
  downloadLink: "Download_Link_für_Media_Portal",
  imageNameJLMediaLibrary: "Bild(er)_aus_jls_Media_Library",
};
